module.exports = __webpack_public_path__ + "static/media/quote1.daab7658.png";


//////////////////
// WEBPACK FOOTER
// ./src/static/img/quote1.png
// module id = 23
// module chunks = 0